<template>
  <div
    class="home_layout"
  >
    <router-view />
  </div>

  <BottomAppBar v-if="!hideNavBar" />
</template>

<script setup>
import {computed} from 'vue'
import BottomAppBar from '@product/components/BottomAppBar/BottomAppBar.vue'
import store from '@/store/store.js'

const hideNavBar = computed(() => store.state.app.hideNavBar)
</script>

<style lang="scss" scoped>
@import "@/assets/variables";

.home_layout {
  display: flex;
  flex-direction: column;
  overflow: auto;
  flex-grow: 1;
}
</style>
